<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true"
  class="modal-container"
  [style.width]="modal.options.width"
  [class.fullscreen]="modal.options.layout?.fullScreen"
  [class.fullscreen-mobile]="modal.options.layout?.fullScreenOnMobile"
  >
  @if (modal.options.title) {
    <div class="modal-container-header">
      @if (modal.options.badgeIcon) {
        <span><app-badge [icon]="modal.options.badgeIcon"></app-badge></span>
      }
      @if (modal.options.title) {
        <span>{{ modal.options.title }}</span>
      }
    </div>
  }

  @if (modal.options.subtitle) {
    <div class="modal-container-content">
      <span>{{ modal.options.subtitle }}</span>
    </div>
  }

  <ng-template appContainerDirective/>

  @if (modal.options.showCloseButton) {
    <a aria-label="Sluiten" class="close" (click)="close()" (keyup.enter)="close()" tabindex="0">
      <app-icon icon="close"/>
    </a>
  }
</div>
